import type { Account } from 'store/models/user';

const TARGET_ACCOUNT_ID_PARAM = 'target_account_id';
const LOGIN_ROUTE_PATH = '/new/login';
const ACCOUNT_ID_MAX_LENGTH = 10;
const POSITIVE_INTEGER_REGEX = /^\d+$/;

export const parseTargetAccountIdFromUrl = (): string | null =>
    new URLSearchParams(window.location.search).get(TARGET_ACCOUNT_ID_PARAM);

export const validateTargetAccountId = (value: string | null): number | null => {
    if (!value || value.length > ACCOUNT_ID_MAX_LENGTH || !POSITIVE_INTEGER_REGEX.test(value)) {
        return null;
    }

    return Number(value) || null;
};

export const shouldSwitchToTargetAccount = (
    accounts: Account[],
    targetAccountId: string | null,
    currentAccountId?: string
): boolean => {
    if (accounts.length <= 1 || !targetAccountId || currentAccountId === targetAccountId) {
        return false;
    }

    return accounts.some(({ id }) => String(id) === targetAccountId);
};

const isLoginPathname = (pathname: string): boolean => pathname.startsWith(LOGIN_ROUTE_PATH);

export const clearTargetAccountIdFromUrl = (): boolean => {
    if (isLoginPathname(window.location.pathname)) {
        return false;
    }

    const url = new URL(window.location.href);

    if (!url.searchParams.has(TARGET_ACCOUNT_ID_PARAM)) {
        return false;
    }

    url.searchParams.delete(TARGET_ACCOUNT_ID_PARAM);

    window.history.replaceState(window.history.state, document.title, `${url.pathname}${url.search}${url.hash}`);

    return true;
};

export const readAndClearTargetAccountId = (): number | null => {
    const targetAccountId = parseTargetAccountIdFromUrl();
    if (targetAccountId) {
        clearTargetAccountIdFromUrl();
    }
    return validateTargetAccountId(targetAccountId);
};
